import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { find } from "lodash";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { checkAssetTypeAndCallFunction } from "../../../Js/CheckCorrectAnswers";
import Confirmation from "../../Modal/Confirmation";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import { CheckActions } from "../../../Js/ILTActions";
import RefreshIcon from "@mui/icons-material/Refresh";

const presentationAssets = ["WORD"];

const ILTFooterCard = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const navigation = useNavigate();

  // State
  const [alertFlag, setAlertFlag] = useState(false);
  const [correct, setCorrect] = useState(false);
  const [submitButton, setSubmitButton] = useState(true);
  const [showAnswer, setShowAnswer] = useState(false);
  const [previousButton, setPreviousButton] = useState(false);
  const [nextButton, setNextButton] = useState(false);
  const [attempStatus, setAttempStatus] = useState(false);
  const [evalAlert, setEvalAlert] = useState(false);
  let [controlBtnObj, setControlBtnObj] = useState(null);
  let [controlBtnObjIndex, setControlBtnObjIndex] = useState(0);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { attempted, numberOfAttemptes, finish, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );
  const { svgLoad } = useSelector((state) => state.currentILTActions);
  let showAnswerClicked = useSelector((state) => state.currentAsset.showAnswer);

  // Reset all states on load of next asset
  useEffect(() => {
    setShowAnswer(false);
    setSubmitButton(true);
    dispatch(currentAssetSliceActions.setAttempted(false));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(currentAssetSliceActions.setCurrentAttempt(1));
    dispatch(currentAssetSliceActions.setDurationFlag(true));
    dispatch(currentAssetSliceActions.startDuration());
    if (
      props.currentPage + 1 == props.totalPage &&
      userInfo.rolesInfo.title.toLowerCase() !== "learner"
    ) {
      dispatch(currentAssetSliceActions.setFinish(true));
    } else {
      dispatch(currentAssetSliceActions.setFinish(false));
    }
    checkNextButton();
    checkPreviousButton();
  }, [props.currentPage]);

  useEffect(() => {
    if (props.controlButton && props.controlButton.buttons) {
      let controlBtn = find(props.controlButton.buttons, {
        buttonId: "controlbtn",
      });
      setControlBtnObj(controlBtn);
      setControlBtnObjIndex(0);
    }
  }, [props.controlButton]);

  useEffect(() => {
    return () => {
      setControlBtnObjIndex(0);
    };
  }, []);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setDurationFlag(true));
    dispatch(currentAssetSliceActions.startDuration());
  }, [currentAttempt]);

  // For learners after successful show answer show next or finish button
  useEffect(() => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (props.currentPage + 1 == props.totalPage) {
        dispatch(currentAssetSliceActions.setFinish(true));
      } else {
        dispatch(currentAssetSliceActions.setFinish(false));
      }
    }
    if (
      userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      props.currentPage + 1 < props.totalPage &&
      showAnswerClicked
    ) {
      checkNextButton();
    }
  }, [showAnswerClicked]);

  // On answer submit
  const submit = async () => {
    let answerStatus = await checkAssetTypeAndCallFunction(
      props.assetType,
      props.evalMode
    );
    console.log("answerStatus", answerStatus);
    setAttempStatus(answerStatus.attempted);
    // First check attempted or not
    if (answerStatus.attempted) {
      dispatch(currentAssetSliceActions.stopDuration());
      dispatch(currentAssetSliceActions.setDurationFlag(false));
      dispatch(currentAssetSliceActions.resetDuration());
      // change attempted flag in redux as per user role
      // if (
      //   userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      //   answerStatus.evalMode == "auto"
      // ) {
      //   if (numberOfAttemptes == currentAttempt) {
      //     dispatch(currentAssetSliceActions.setAttempted(true));
      //   }
      // } else {
      //   dispatch(currentAssetSliceActions.setAttempted(true));
      // }

      // // If answer is correct then directly set finish or next button
      // if (+answerStatus.score === 1) {
      //   setCorrect(true);
      //   if (props.currentPage + 1 == props.totalPage) {
      //     dispatch(currentAssetSliceActions.setFinish(true));
      //   }
      //   if (
      //     userInfo.rolesInfo.title.toLowerCase() == "learner" &&
      //     props.currentPage + 1 < props.totalPage
      //   ) {
      //     setNextButton(true);
      //   }
      //   dispatch(currentAssetSliceActions.setAttempted(true));
      //   setSubmitButton(false);
      // } else {
      //   setCorrect(false);
      //   // If answer is incorrect increase attempt or set show answer button
      //   if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      //     if (numberOfAttemptes == currentAttempt) {
      //       setSubmitButton(false);
      //     }
      //   } else {
      //     setSubmitButton(false);
      //   }
      // }

      // // Increase current number of attempt
      // if (numberOfAttemptes > currentAttempt && +answerStatus.score < 1) {
      //   dispatch(
      //     currentAssetSliceActions.setCurrentAttempt(currentAttempt + 1)
      //   );
      // }
    } else {
      //dispatch(currentAssetSliceActions.setAttempted(false));
    }
    // if (
    //   userInfo.rolesInfo.title.toLowerCase() == "learner" &&
    //   answerStatus.evalMode &&
    //   answerStatus.evalMode == "manual" &&
    //   answerStatus.attempted
    // ) {
    //   setEvalAlert(true);
    // }

    // if (
    //   !answerStatus.evalMode ||
    //   answerStatus.evalMode == "auto" ||
    //   !answerStatus.attempted
    // ) {
    //   // Open correct answer or incorrect answer popup
    //   setAlertFlag(true);
    // }
  };

  // Check for showanswer
  const checkShowAnswer = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (numberOfAttemptes == currentAttempt) {
        setShowAnswer(true);
      }
    } else {
      setShowAnswer(true);
    }
  };

  // Show Answer
  const showAnswerClick = () => {
    setShowAnswer(false);
    dispatch(currentAssetSliceActions.setShowAnswer(showAnswer));
  };

  // Check previous button visibility
  const checkPreviousButton = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      setPreviousButton(false);
    } else {
      setPreviousButton(props.currentPage + 1 > 1);
    }
  };

  const controlButtonClick = () => {
    controlBtnObj["click"][controlBtnObjIndex]["items"].forEach(
      (val, index) => {
        CheckActions(val,svgLoad ? 'svg':'notSvg');
      }
    );
    setControlBtnObjIndex(controlBtnObjIndex + 1);
  };

  // Check next button visibility
  const checkNextButton = () => {
    if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
      if (props.currentPage < props.totalPage - 1) {
        setNextButton(true);
      } else {
        setNextButton(false);
      }
    } else {
      setNextButton(props.currentPage < props.totalPage - 1);
    }
  };

  const sentForEvalClose = () => {
    if (props.currentPage < props.totalPage - 1) {
      setNextButton(true);
    } else {
      dispatch(currentAssetSliceActions.setFinish(true));
      setSubmitButton(false);
    }
  };

  const refreshILT = () => {
    dispatch(currentAssetSliceActions.setRefreshClick(true));
  };

  return (
    <>
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "space-between",
          flexWrap: "nowrap",
          alignItems: "center",
          px: 6,
        }}
      >
        <Grid item sx={{}}>
          <Grid container sx={{ gap: 3, pt: 1 }}>
            <Grid item>
              <Box sx={{ border: 1, borderColor: "#5f5600ff", borderRadius: 10 }}>
                <Typography
                  sx={{
                    color: "#5f5600ff",
                    padding: 1,
                    fontSize: "0.8rem",
                    textAlign: "center",
                    fontWeight: "400",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                      padding: 2,
                    },
                  }}
                >
                  Page {props.currentPage + 1} | {props.totalPage}
                </Typography>
              </Box>
            </Grid>
            {/* <Grid item>
              {userInfo.rolesInfo.title.toLowerCase() == "learner" &&
                props.evalMode == "auto" && (
                  <Box
                    sx={{ border: 1, borderColor: "#BBB", borderRadius: 10 }}
                  >
                    <Typography
                      sx={{
                        color: "#888",
                        padding: 1,
                        fontSize: "0.8rem",
                        textAlign: "center",
                        fontWeight: "400",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                          padding: 2,
                        },
                      }}
                    >
                      Attempt {currentAttempt} | {numberOfAttemptes}
                    </Typography>
                  </Box>
                )}
            </Grid> */}
          </Grid>
        </Grid>
        <Grid item sx={{}}>
          <Grid
            container
            sx={{ gap: 2, alignItems: "center", paddingTop: 0.8 }}
          >
            <Grid item>
              <Box>
                {previousButton && (
                  <IconButton
                    sx={{ marginTop: "0.2rem" }}
                    disabled={!props.ignoreNextPre}
                    onClick={() => {
                      submit();
                      props.previous();
                    }}
                  >
                    <NavigateBeforeIcon
                      sx={{
                        fontSize: "2rem",
                        color: "#5f5600ff",
                        "@media (min-width: 1636px)": {
                          fontSize: "3.2rem",
                        },
                      }}
                    />
                  </IconButton>
                )}
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{ borderRadius: 10 }}>
                {controlBtnObj &&
                  controlBtnObj["click"].length > 0 &&
                  +controlBtnObjIndex < controlBtnObj["click"].length && (
                    <Button
                      sx={{
                        color: "#5f5600ff",
                        width: "10vw",
                        textTransform: "inherit",
                        borderRadius: 10,
                        boxShadow: 3,
                        fontWeight: "600",
                        fontSize: "1rem",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      }}
                      onClick={controlButtonClick}
                    >
                      {
                        controlBtnObj["click"][controlBtnObjIndex][
                          "displayString"
                        ]
                      }
                    </Button>
                  )}
              </Box>
            </Grid>
            <Grid item>
              <Box color="#5f5600ff">
                {nextButton && (
                  <IconButton
                    sx={{ marginTop: "0.2rem" }}
                    disabled={!props.ignoreNextPre}
                    onClick={() => {
                      submit();
                      props.next();
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        fontSize: "2rem",
                        color: "#5f5600ff",
                        "@media (min-width: 1636px)": {
                          fontSize: "3.2rem",
                        },
                      }}
                    />
                  </IconButton>
                )}
                {finish && (
                  <Button
                    sx={{
                      width: "10vw",
                      textTransform: "inherit",
                      borderRadius: 10,
                      boxShadow: 3,
                      fontWeight: "600",
                      fontSize: "1rem",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                      },
                    }}
                    onClick={() => {
                      submit();
                      props.finishClick("ILT");
                    }}
                  >
                    Finish
                  </Button>
                )}
                <IconButton sx={{ marginTop: "0.2rem" }} onClick={refreshILT}>
                  <RefreshIcon
                    sx={{
                      fontSize: "2rem",
                      color: "#5f5600ff",
                      "@media (min-width: 1636px)": {
                        fontSize: "3.2rem",
                      },
                    }}
                  />
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Confirmation
        visible={alertFlag}
        primaryText={
          !attempStatus
            ? "Please attempt"
            : correct
            ? "Congratulations !"
            : "Incorrect"
        }
        image={correct ? "complete" : "error"}
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={3000}
        onClose={() => {
          setCorrect(false);
          if (attempted && !correct) {
            checkShowAnswer();
            setAttempStatus(false);
          }
        }}
      ></Confirmation>
      <Confirmation
        visible={evalAlert}
        primaryText="Sent for evaluation"
        image={"complete"}
        alert={true}
        toggleModal={(flag) => setEvalAlert(flag)}
        timeout={3000}
        onClose={() => {
          if (attempted) {
            setAttempStatus(true);
            showAnswerClick();
            sentForEvalClose();
          }
        }}
      ></Confirmation>
    </>
  );
};

export default ILTFooterCard;
